/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrTextHeader } from './igr-text-header';
import { TextHeader } from './TextHeader';
import { TypeRegistrar } from "igniteui-react-core";
var IgrTextHeaderModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrTextHeaderModule() {
    }
    IgrTextHeaderModule.register = function () {
        TypeRegistrar.registerCons("IgrTextHeader", IgrTextHeader);
        TypeRegistrar.register("TextHeader", TextHeader.$type);
    };
    return IgrTextHeaderModule;
}());
export { IgrTextHeaderModule };
//# sourceMappingURL=igr-text-header-module.js.map
